import React from "react";
import PropTypes from "prop-types";

export const STATE_LABELS = {
  Unallocated: "Unallocated",
  AllocatedToCoach: "With coach",
  AllocatedToSynthpop: "With Synthpop",
  ContactedToday: "Contacted today",
  FailedAutomation: "Failed automation"
};

export const STATE_CLASSES = {
  Unallocated: "outreach-state-badge--unallocated",
  AllocatedToCoach: "outreach-state-badge--coach",
  AllocatedToSynthpop: "outreach-state-badge--synthpop",
  ContactedToday: "outreach-state-badge--contacted",
  FailedAutomation: "outreach-state-badge--failed"
};

const OutreachStateBadge = ({
  outreachState,
  isSynthpopWaitingOnCallback = false
}) => {
  const label = STATE_LABELS[outreachState] || outreachState || "Unknown";
  const cls = STATE_CLASSES[outreachState] || "outreach-state-badge--unknown";

  return (
    <span className="outreach-state-badge__wrap">
      <span className={`outreach-state-badge ${cls}`}>{label}</span>
      {outreachState === "AllocatedToSynthpop" &&
        isSynthpopWaitingOnCallback && (
          <span className="outreach-state-badge__sub">
            waiting on callback
          </span>
        )}
    </span>
  );
};

OutreachStateBadge.propTypes = {
  outreachState: PropTypes.string,
  isSynthpopWaitingOnCallback: PropTypes.bool
};

export default OutreachStateBadge;
